import dayjs, { Dayjs } from 'dayjs'
import { ListingPositionEnum } from '../types'

import type { Listing } from '../../../reducers/types/reducerTypes'

const getListingPosition = (
  listing: Listing,
  now: Dayjs,
  scheduleStart: Dayjs,
  scheduleEnd: Dayjs
): ListingPositionEnum => {
  const listingStart = dayjs(listing.start_time)
  const listingEnd = listingStart.add(listing.duration, 'second')
  const startsBeforeScheduleStart = listingStart.isBefore(
    scheduleStart,
    'minute'
  )
  const startsAtScheduleStart = listingStart.isSame(scheduleStart, 'minute')
  const isAiringNow = now.isAfter(listingStart) && now.isBefore(listingEnd)
  const startsAfterScheduleStart = listingStart.isAfter(scheduleStart, 'minute')
  const startsAfterScheduleEnd =
    listingStart.isAfter(scheduleEnd, 'minute') ||
    listingStart.isSame(scheduleEnd, 'minute')
  const endsBeforeScheduleStart =
    listingEnd.isBefore(scheduleStart, 'minute') ||
    listingEnd.isSame(scheduleStart, 'minute')
  const endsBeforeScheduleEnd = listingEnd.isBefore(scheduleEnd, 'minute')
  const endsAtScheduleEnd = listingEnd.isSame(scheduleEnd, 'minute')
  const endsAfterScheduleEnd = listingEnd.isAfter(scheduleEnd, 'minute')

  switch (true) {
    case startsBeforeScheduleStart:
      if (endsBeforeScheduleStart) {
        return ListingPositionEnum.startsBeforeScheduleStartAndEnded
      } else if (!endsBeforeScheduleStart) {
        if (endsBeforeScheduleEnd) {
          return ListingPositionEnum.startsBeforeScheduleStartButNotEnded
        } else if (endsAtScheduleEnd) {
          return ListingPositionEnum.startsBeforeScheduleStartEndsAtScheduleEnd
        } else if (endsAfterScheduleEnd) {
          return ListingPositionEnum.listingLongerThanSchedule
        }
      }
      return ListingPositionEnum.notInSchedule
    case startsAtScheduleStart:
      if (!isAiringNow) {
        return ListingPositionEnum.startsAtScheduleStartAndIsEnded
      } else if (endsBeforeScheduleEnd) {
        return ListingPositionEnum.startsAtScheduleStart
      } else if (endsAtScheduleEnd) {
        return ListingPositionEnum.listingSameAsSchedule
      } else if (endsAfterScheduleEnd) {
        return ListingPositionEnum.startsAtScheduleStartEndsAfterScheduleEnd
      }
      return ListingPositionEnum.notInSchedule
    case startsAfterScheduleStart:
      if (startsAfterScheduleEnd) {
        return ListingPositionEnum.startsAfterScheduleEnd
      } else if (endsBeforeScheduleEnd || endsAtScheduleEnd) {
        return ListingPositionEnum.duringSchedule
      } else if (endsAfterScheduleEnd) {
        return ListingPositionEnum.duringScheduleEndsAfterScheduleEnd
      }
      return ListingPositionEnum.notInSchedule
    default:
      return ListingPositionEnum.notInSchedule
  }
}

export { getListingPosition }
